// extracted by mini-css-extract-plugin
export var bannerContainer = "_0-0";
export var bannerImage = "_0-2";
export var bannerLoading = "_0-3";
export var bannerWrapper = "_0-1";
export var shimmer = "_0-4";